/*
 * The dashboard is the LCP image. Mobile renders it at ~330–380 CSS px, so a
 * 1024w-only source wasted most of its bytes; these must stay in sync with the
 * <link rel="preload"> in each locale's layout.js or the preload is discarded.
 */
export const ME_HERO_DASHBOARD_SRCSET = [
  '/wp-content/uploads/me-cx/hero-main-dashboard-480w.webp 480w',
  '/wp-content/uploads/me-cx/hero-main-dashboard-640w.webp 640w',
  '/wp-content/uploads/me-cx/hero-main-dashboard.webp 1024w',
].join(', ');

export const ME_HERO_DASHBOARD_SIZES = '(max-width: 900px) calc(100vw - 64px), 64vw';

/** ME LP hero scatter — positions tuned to Figma reference (2044×698 stage). */
export const ME_HERO_COLLAGE = [
  {
    id: 'dashboard',
    src: '/wp-content/uploads/me-cx/hero-main-dashboard.webp',
    srcSet: ME_HERO_DASHBOARD_SRCSET,
    sizes: ME_HERO_DASHBOARD_SIZES,
    alt: 'Locobuzz Arabic customer experience dashboard',
    left: 17, top: 14, width: 64, z: 1, primary: true,
    intrinsicWidth: 1024,
    intrinsicHeight: 583,
  },
  {
    src: '/wp-content/uploads/me-cx/hero-accent-social.webp',
    alt: 'Social post with live engagement metrics',
    left: 1, top: 26, width: 15, z: 3, float: 'A',
    // Not primary — mobile shows only the dashboard LCP image
  },
  {
    src: '/wp-content/uploads/me-cx/hero-accent-workflow.webp',
    alt: 'Workflow automation builder',
    left: 83, top: 0, width: 17, z: 3, float: 'B',
  },
  {
    src: '/wp-content/uploads/me-cx/hero-accent-wordcloud.webp',
    alt: 'Arabic sentiment word cloud',
    left: 73, bottom: -32, width: 27, z: 4, float: 'A',
  },
];
